'use strict';

var _successCallback;
var _failCallback;
var _captchaID;

(function(){
    var scriptToBeLoaded = document.querySelector('#tencentCaptchaScript[src]');
    if (! scriptToBeLoaded) {
        var script = document.querySelector('#tencentCaptchaScript:not([src])');
        if (script) {
            script.setAttribute('src', script.getAttribute('data-src'));
        }
    }
})();

function tencetCaptchaCallback(res) {
    if (res.ret === 0) {
        // successful verification
        $(`.js-tencent-captcha-container[data-id=${_captchaID}] [name="tencent_captcha_randstr"]`).val(res.randstr);
        $(`.js-tencent-captcha-container[data-id=${_captchaID}] [name="tencent_captcha_ticket"]`).val(res.ticket);
        
        if (! res.errorCode) {
            if (_successCallback) {
                _successCallback({
                    randstr: res.randstr,
                    ticket: res.ticket
                });
            }
            
        } else { // error
            if (_failCallback) _failCallback();
        }
    } else {
        if (_failCallback) _failCallback();
        // console.log('errorCode:', res.errorCode, 'errorMessage:', res.errorMessage);
    }
}

function tencetCaptchaLoadingErrCallback(error) {
    if (_failCallback) _failCallback();
}

function showCaptcha (config = {}) {
   _captchaID = config.captchaID;
   _successCallback = config.success;
   _failCallback = config.fail;

   try {
       var captchaAppID = $('.js-tencentCaptchaAppID').val();
       var captcha = new TencentCaptcha(captchaAppID, tencetCaptchaCallback, {});
       captcha.show();
   } catch (error) {
       tencetCaptchaLoadingErrCallback(error);
   }
}

module.exports = {
    verify: function() {
        $.ajax({
            type: 'POST',
            url: $('input[name="tencent-captcha-verify-url"]').val(),
            data: {
                randstr: $(`.js-tencent-captcha-container[data-id=${_captchaID}] [name="tencent_captcha_randstr"]`).val(),
                ticket:  $(`.js-tencent-captcha-container[data-id=${_captchaID}] [name="tencent_captcha_ticket"]`).val(),
            },
            success: function(data) {
                if (data.success) {
                    if (_successCallback) _successCallback(data);
                } else {
                    if (_failCallback) _failCallback(data);
                    $(`.js-tencent-captcha-container[data-id=${_captchaID}] [name="tencent_captcha_ticket"]`).val('');
                }
            },
            error: function(data) {
                if (_failCallback) _failCallback(data);
                $(`.js-tencent-captcha-container[data-id=${_captchaID}] [name="tencent_captcha_ticket"]`).val('');
            }
        });
    },

    /**
     * Check if the Tencent captcha script has already been loaded into the HTML.
     */
    isAlreadyLoaded: function() {
        return $('#tencentCaptchaScript').length;
    },

    /**
     * Show the Tencent captcha popup
     * @param {JQuery} $tencentCaptchaEl 
     * @param {Promise} promise 
     */
    initialize: function($tencentCaptchaEl, promise) {
        var $captchaInput = $('input[name="tencent_captcha_ticket"]', $tencentCaptchaEl);
        if ($captchaInput.length && !$captchaInput.val()) {
            showCaptcha({
                captchaID: $tencentCaptchaEl.attr('data-id'),
                success: (data) => promise.resolve(data),
                fail: () => promise.reject()
            });
        } else {
            const ticket = $captchaInput.val();
            const randstr = $(`.js-tencent-captcha-container[data-id=${_captchaID}] [name="tencent_captcha_randstr"]`).val();
            promise.resolve({ ticket, randstr });
        }
    },

    /**
     * Invalidate the captcha element
     * @param {JQuery} $tencentCaptchaEl 
     */
    invalidateCaptcha: function($tencentCaptchaEl) {
        $('input[name="tencent_captcha_ticket"]', $tencentCaptchaEl).val('');
    },

    addTokenToFormData: function(formData, container) {
        if ($('[name="tencent_captcha_randstr"]', container).length) {
            Object.assign(formData, { tencent_captcha_randstr: $('[name="tencent_captcha_randstr"]', container).val() });
            Object.assign(formData, { tencent_captcha_ticket: $('[name="tencent_captcha_ticket"]', container).val() });
        }
        return formData;
    }
};
